module.exports = __webpack_public_path__ + "static/media/voice.798fe8fd.svg";